import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'usPhoneFormat',
    standalone: true,
})
export class UsPhoneFormatPipe implements PipeTransform {
    transform(value: string | number | null | undefined): string {
        if (value === null || value === undefined) {
            return '';
        }

        const input = String(value).trim();
        if (!input) {
            return '';
        }

        const digits = input.replace(/\D/g, '');

        // Support common US inputs including optional leading country code.
        const normalizedDigits = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

        if (normalizedDigits.length !== 10) {
            return input;
        }

        const areaCode = normalizedDigits.slice(0, 3);
        const prefix = normalizedDigits.slice(3, 6);
        const lineNumber = normalizedDigits.slice(6);

        return `(${areaCode}) ${prefix}-${lineNumber}`;
    }
}
